import React from 'react';
import Footer from '../components/global/footer';
import Header from '../components/global/header';

const PrivacyPage = ({ history }) => {
  const goHome = () => history.push('/');

  return (
    <div>
      <Header />
      <main className="about_main">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="about_page">
                <h1 className="title text-center">
                  Політика конфіденційності та обробки персональних даних
                </h1>

                <div className="privacy-content">
                  <p className="privacy-subtitle">Вебсервіс «Лікарі 24/7»</p>
                  <p className="privacy-edition">
                    Редакція 1.1 від 14.09.2026 • для публікації на{' '}
                    <a href="https://likari.in.ua" target="_blank" rel="noopener noreferrer">
                      likari.in.ua
                    </a>
                  </p>

                  <div className="privacy-summary">
                    <strong>Коротко:</strong> «Лікарі 24/7» є пацієнтським вебсервісом, технологічно
                    та функціонально пов’язаним з МІС «Каштан». Ця Політика пояснює, які персональні
                    дані обробляються під час користування вебсервісом, для яких цілей, кому вони можуть
                    бути доступні та як користувач може реалізувати свої права.
                  </div>

                  <section>
                    <h2>1. Загальні положення</h2>
                    <p><strong>1.1.</strong> Ця Політика застосовується до використання вебсервісу «Лікарі 24/7» за адресою <a href="https://likari.in.ua" target="_blank" rel="noopener noreferrer">https://likari.in.ua</a>, зокрема до пошуку медичного працівника або кабінету, перегляду доступного часу, онлайн-запису та кабінету користувача.</p>
                    <p><strong>1.2.</strong> «Лікарі 24/7» є пацієнтським вебсервісом, технологічно та функціонально пов’язаним з медичною інформаційною системою «Каштан» (далі – МІС «Каштан»). Через вебсервіс доступний пошук та запис виключно до медичних працівників і закладів охорони здоров’я, які використовують МІС «Каштан».</p>
                    <p><strong>1.3.</strong> Оператором МІС «Каштан» є ТОВ «СІЕТ ХОЛДІНГ», код ЄДРПОУ 39197392 (далі – Товариство). Товариство є розробником програмного забезпечення МІС «Каштан» та здійснює його технічну підтримку.</p>
                  </section>

                  <section>
                    <h2>2. Учасники обробки персональних даних</h2>
                    <p><strong>2.1.</strong> У межах роботи вебсервісу в обробці персональних даних можуть брати участь Товариство, відповідний заклад охорони здоров’я та залучені до технічного функціонування сервісу постачальники.</p>
                    <p><strong>2.2.</strong> Заклади охорони здоров’я обробляють персональні та медичні дані пацієнтів у межах надання медичної допомоги та виконання інших функцій, визначених законодавством.</p>
                    <p><strong>2.3.</strong> Товариство забезпечує роботу та технічну підтримку програмного забезпечення МІС «Каштан» і пов’язаного з нею вебсервісу. Конкретна роль Товариства щодо окремих наборів даних визначається характером відповідної операції, договорами та законодавством.</p>
                  </section>

                  <section>
                    <h2>3. Які персональні дані обробляються та звідки вони надходять</h2>
                    <p>Під час користування вебсервісом обробляються дані, необхідні для роботи обраної користувачем функції, зокрема:</p>
                    <ul>
                      <li>ідентифікаційні та контактні дані, необхідні для авторизації та створення запису, зокрема ім’я та номер телефону;</li>
                      <li>дані про онлайн-запис: обраний заклад, медичний працівник або кабінет, послуга чи процедура, дата і час, статус запису, відомості про його зміну або скасування;</li>
                      <li>дані кабінету користувача, зокрема відомості про попередні та майбутні записи в межах доступної функціональності;</li>
                      <li>технічні дані, необхідні для роботи та безпеки сервісу: IP-адреса, дата і час звернення, параметри пристрою та браузера, ідентифікатори сесії, технічні журнали;</li>
                      <li>дані звернень до служби технічної підтримки.</li>
                    </ul>
                    <p>Дані надходять безпосередньо від користувача, від відповідного закладу охорони здоров’я та з МІС «Каштан» у межах доступної вебсервісу функціональності. Відомості про запис до певного лікаря, спеціальності, процедури чи закладу можуть прямо або опосередковано стосуватися стану здоров’я та потребують належного захисту.</p>
                  </section>

                  <section>
                    <h2>4. Мета та правові підстави обробки</h2>
                    <p>Персональні дані обробляються для:</p>
                    <ul>
                      <li>пошуку медичного працівника або закладу, перегляду розкладу та здійснення онлайн-запису;</li>
                      <li>ідентифікації та автентифікації користувача;</li>
                      <li>створення, відображення, зміни та скасування записів у межах доступної функціональності;</li>
                      <li>забезпечення технічної взаємодії вебсервісу з МІС «Каштан» і відповідним закладом охорони здоров’я;</li>
                      <li>технічної підтримки, усунення помилок, забезпечення інформаційної безпеки та запобігання несанкціонованому доступу;</li>
                      <li>виконання обов’язків, прямо встановлених законодавством.</li>
                    </ul>
                    <p>Обробка здійснюється на підставах, передбачених законодавством України про захист персональних даних та законодавством у сфері охорони здоров’я. Залежно від конкретної операції такою підставою може бути згода особи або інша підстава, прямо передбачена законом. Якщо для окремої операції необхідна згода користувача, вона запитується окремо у відповідному сценарії.</p>
                  </section>

                  <section>
                    <h2>5. Кому можуть бути доступні персональні дані</h2>
                    <p>У межах визначених цілей та правових підстав доступ до персональних даних можуть отримувати:</p>
                    <ul>
                      <li>відповідний заклад охорони здоров’я та його уповноважені працівники;</li>
                      <li>ТОВ «СІЕТ ХОЛДІНГ» – у межах технічної експлуатації, підтримки та забезпечення безпеки МІС «Каштан» і вебсервісу;</li>
                      <li>постачальники технічної інфраструктури та телекомунікаційних послуг, залучені до роботи вебсервісу, – лише в обсязі, необхідному для виконання відповідної технічної функції;</li>
                      <li>інші особи – лише у випадках, прямо передбачених законом або належною правовою підставою.</li>
                    </ul>
                  </section>

                  <section>
                    <h2>6. МІС «Каштан» та ЕСОЗ</h2>
                    <p><strong>6.1.</strong> МІС «Каштан» підключена до центральної бази даних електронної системи охорони здоров’я (ЕСОЗ) у межах функціональності, передбаченої законодавством та технічними вимогами.</p>
                    <p><strong>6.2.</strong> Вебсервіс «Лікарі 24/7» не є державним Кабінетом пацієнта ЕСОЗ і не надає автоматичного доступу до повного обсягу електронної медичної інформації, що може міститися у ЦБД ЕСОЗ.</p>
                  </section>

                  <section>
                    <h2>7. Cookies і технічні дані</h2>
                    <p>Для забезпечення роботи сесії, авторизації, безпеки та коректного функціонування вебсервісу можуть використовуватися технічні файли cookie та аналогічні технології. Технічні дані використовуються лише для роботи, захисту та діагностики вебсервісу.</p>
                  </section>

                  <section>
                    <h2>8. Строки зберігання та захист даних</h2>
                    <p><strong>8.1.</strong> Персональні дані зберігаються не довше, ніж це необхідно для досягнення визначених цілей, виконання договірних і законодавчих обов’язків, забезпечення безпеки та захисту прав учасників відповідних правовідносин. Конкретні строки залежать від виду даних та вимог, що застосовуються до відповідної операції.</p>
                    <p><strong>8.2.</strong> Застосовуються організаційні та технічні заходи, спрямовані на запобігання випадковому або незаконному знищенню, втраті, зміні, несанкціонованому розкриттю чи доступу до персональних даних.</p>
                  </section>

                  <section>
                    <h2>9. Права користувача</h2>
                    <p>Користувач має права, передбачені законодавством України про захист персональних даних, зокрема право:</p>
                    <ul>
                      <li>знати про джерела збирання, мету обробки своїх персональних даних та осіб, яким вони передаються у випадках, передбачених законом;</li>
                      <li>отримувати інформацію про умови надання доступу до персональних даних;</li>
                      <li>отримувати доступ до своїх персональних даних;</li>
                      <li>вимагати виправлення неточних або застарілих даних;</li>
                      <li>пред’являти вмотивовану вимогу щодо заперечення проти обробки, зміни або знищення даних у випадках, передбачених законом;</li>
                      <li>оскаржувати обробку персональних даних до Уповноваженого Верховної Ради України з прав людини або до суду;</li>
                      <li>відкликати згоду, якщо конкретна обробка здійснюється саме на підставі згоди і відсутня інша законна підстава для її продовження.</li>
                    </ul>
                    <p>Для реалізації прав може знадобитися перевірка особи заявника, щоб не допустити розкриття персональних даних сторонній особі.</p>
                  </section>

                  <section>
                    <h2>10. Зміни до Політики та контакти</h2>
                    <p><strong>10.1.</strong> Політика може періодично оновлюватися. Актуальна редакція із зазначенням дати публікується на сайті <a href="https://likari.in.ua" target="_blank" rel="noopener noreferrer">https://likari.in.ua</a>.</p>
                    <p><strong>10.2.</strong> Контакт для звернень щодо вебсервісу та персональних даних:</p>
                    <address className="privacy-contact">
                      <div>ТОВ «СІЕТ ХОЛДІНГ», код ЄДРПОУ 39197392;</div>
                      <div>адреса: 01033, м. Київ, вул. Шота Руставелі, 33-Б, оф. 27;</div>
                      <div>e-mail: <a href="mailto:info@ciet-holding.com">info@ciet-holding.com</a>.</div>
                    </address>
                    <p>У зверненні доцільно описати питання та зазначити контакт для відповіді. Не слід надсилати зайві медичні відомості або інші персональні дані, якщо вони не потрібні для розгляду звернення.</p>
                  </section>
                </div>

                <div className="link_to_home" onClick={goHome}>
                  На головну
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <style>{`
        .privacy-content {
          line-height: 1.6;
          margin-bottom: 2rem;
          font-size: 16px;
        }

        .privacy-content section {
          margin-bottom: 2.5rem;
        }

        .privacy-content .privacy-subtitle,
        .privacy-content .privacy-edition {
          text-align: center;
          color: #34495e;
        }

        .privacy-content .privacy-subtitle {
          margin-bottom: 0.4rem;
          font-size: 1.1rem;
          font-weight: 600;
        }

        .privacy-content .privacy-edition {
          margin-bottom: 3rem;
        }

        .privacy-summary {
          margin-bottom: 3rem;
          padding: 1rem 1.25rem;
          background-color: #eef3f8;
          border-left: 4px solid #3498db;
          color: #2c3e50;
        }

        .privacy-summary strong {
          color: #2c3e50;
        }

        .privacy-content h2 {
          font-size: 1.4rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
          color: #2c3e50;
          border-bottom: 2px solid #3498db;
          padding-bottom: 0.5rem;
        }

        .privacy-content p {
          margin-bottom: 1.2rem;
          text-align: justify;
          color: #2c3e50;
        }

        .privacy-content ul {
          list-style-type: disc;
          padding-left: 2rem;
          margin-bottom: 1.5rem;
        }

        .privacy-content li {
          margin-bottom: 0.8rem;
          color: #2c3e50;
        }

        .privacy-content strong {
          color: #2980b9;
          font-weight: 600;
        }

        .privacy-content a {
          color: #3498db;
          text-decoration: none;
          font-weight: 500;
        }

        .privacy-content a:hover {
          color: #2980b9;
          text-decoration: underline;
        }

        .privacy-contact {
          margin: 0 0 1.2rem;
          color: #2c3e50;
          font-style: normal;
        }

        .link_to_home {
          display: inline-block;
          padding: 0.75rem 1.5rem;
          background-color: #3498db;
          color: white;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.3s ease;
          margin-top: 2rem;
          text-decoration: none;
        }

        .link_to_home:hover {
          background-color: #2980b9;
          box-shadow: 0 4px 8px rgba(0,0,0,0.15);
          transform: translateY(-1px);
        }

        @media (max-width: 768px) {
          .privacy-content {
            font-size: 14px;
          }

          .privacy-content h2 {
            font-size: 1.2rem;
          }

          .privacy-content ul {
            padding-left: 1.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPage;
